export enum AnalyticsEvent {
  PageView = "PageView",
  PageLoaded = "PageLoaded",
  Click = "Click",
  Login = "Login",
  UninitializedDomain = "UninitializedDomain",
  SendMagicLink = "SendMagicLink",
  SendMagicLinkTest = "SendMagicLinkTest",
  Error = "Error",
  ApplicationCreation = "ApplicationCreation",
  AddMemberClicked = "AddMemberClicked",
  DepositCollectorLoaded = "DepositPaymentLoaded",
  DepositCollectorClicked = "DepositCollectorClicked",
  DepositCollectorSuccess = "DepositCollectorSuccess",
  LandbotEvent = "LandbotEvent",
  ApplicationAction = "ApplicationAction",
  UnsubscribeLead = "UnsubscribeLead"}



// WEBPACK FOOTER //
// ./src/services/Analytics/AnalyticsConstants.ts